import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';

const statusConfig = {
  sugerida: { label: 'Sugerida', color: 'text-[var(--text-secondary)]', bg: 'bg-[var(--bg-base)]', border: 'border-[var(--border-subtle)]' },
  aceptada: { label: 'Aceptada', color: 'text-brand-cyan', bg: 'bg-brand-cyan/10', border: 'border-brand-cyan/30' },
  en_proceso: { label: 'En Proceso', color: 'text-brand-gold-dark', bg: 'bg-brand-gold/10', border: 'border-brand-gold/30' },
  completada: { label: 'Completada', color: 'text-brand-green', bg: 'bg-brand-green/10', border: 'border-brand-green/30' },
  no_por_ahora: { label: 'No por ahora', color: 'text-rose-500', bg: 'bg-rose-500/10', border: 'border-rose-500/30' },
};

export default function SuggestionCard({ suggestion, isLeader, onUpdateStatus }) {
  const [upvotes, setUpvotes] = useState(suggestion.upvotes);
  const [hasVoted, setHasVoted] = useState(false);

  const handleVote = () => {
    if (hasVoted) setUpvotes(prev => prev - 1);
    else setUpvotes(prev => prev + 1);
    setHasVoted(!hasVoted);
  };

  const config = statusConfig[suggestion.status];

  return (
    <div className="bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-2xl p-5 shadow-sm hover:shadow-md transition-all flex flex-col gap-4">
      {/* Header: Status & Votos */}
      <div className="flex items-start justify-between gap-4">
        <div className={`px-2.5 py-1 rounded-lg border ${config.bg} ${config.border} ${config.color} text-[9px] font-black uppercase tracking-widest flex items-center gap-1.5`}>
          <div className={`w-1.5 h-1.5 rounded-full bg-current`} />
          {config.label}
        </div>
        
        <button 
          onClick={handleVote}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border transition-all ${
            hasVoted 
              ? 'bg-brand-cyan border-brand-cyan text-white shadow-md' 
              : 'bg-[var(--bg-base)] border-[var(--border-subtle)] text-[var(--text-secondary)] hover:border-brand-cyan hover:text-brand-cyan'
          }`}
        >
          <SafeIcon name="ChevronUp" className="w-4 h-4" />
          <span className="text-xs font-black">{upvotes}</span>
        </button>
      </div>

      {/* Content */}
      <div>
        <h4 className="text-sm font-black text-[var(--text-main)] uppercase tracking-tight leading-tight mb-2">
          {suggestion.title}
        </h4>
        <p className="text-xs text-[var(--text-main)]/70 font-medium leading-relaxed line-clamp-3">
          {suggestion.description}
        </p>
      </div>

      {/* Footer: Author & Leader Controls */}
      <div className="mt-auto pt-4 border-t border-[var(--border-subtle)] flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 rounded-full bg-brand-navy flex items-center justify-center text-[8px] font-black text-white">
            {suggestion.authorAvatar}
          </div>
          <span className="text-[9px] font-bold text-[var(--text-secondary)] uppercase tracking-widest">
            {suggestion.author}
          </span>
        </div>

        {isLeader && (
          <select 
            value={suggestion.status}
            onChange={(e) => onUpdateStatus(suggestion.id, e.target.value)}
            className="bg-[var(--bg-base)] border border-[var(--border-subtle)] text-[var(--text-main)] text-[9px] font-bold uppercase tracking-widest rounded-lg px-2 py-1 outline-none focus:border-brand-cyan"
          >
            <option value="sugerida">Mover a Sugerida</option>
            <option value="aceptada">Mover a Aceptada</option>
            <option value="en_proceso">Mover a En Proceso</option>
            <option value="completada">Mover a Completada</option>
            <option value="no_por_ahora">Mover a No por ahora</option>
          </select>
        )}
      </div>
    </div>
  );
}